import {ref} from "vue";
import {useLog} from "@/composables/useLog";
import {authFetch} from "@/composables/useAuthFetch";

const log = useLog("useSaveIsSubscribed");

// a link asked to subscribe (e.g. /2026's "update your preferences"): Profile's list switches
// (SettingsSubscribe.vue) turn on in view, then clear it
export const isSubscribeRequested = ref(false);

export function requestSubscribe() {
  isSubscribeRequested.value = true;
}

async function refreshClerkUser(user) {
  try {
    await window.Clerk?.session?.touch();
    await user.reload();
    log("clerk user refreshed");
  } catch (error) {
    log(`clerk refresh failed: ${error?.message}`);
  }
}

export function useSaveIsSubscribed() {
  const isSaving = ref(false);

  // publicMetadata: the settings changed, e.g. {subscriptions: ["workshop"]} (the mailing lists),
  // {privacy: {letOthersContactMe: false}} (subscriptionLists.js; 2026-10-20)
  async function save(user, publicMetadata) {
    if (!user) return false;
    isSaving.value = true;
    try {
      const body = {
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        publicMetadata,
        overwrite: true,
      };
      const response = await authFetch("/api/v1/user/update/clerk", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(body),
      });
      const data = await response.json();
      log(`save result: ok=${data.ok}`);
      if (data.ok) await refreshClerkUser(user);
      return data.ok === true;
    } catch (error) {
      log(`save error: ${error?.message}`);
      return false;
    } finally {
      isSaving.value = false;
    }
  }

  return {isSaving, save};
}
